;(function() {
  'use strict'

  Controller.$inject = ["glUtils", "QuotaVariable"];
  angular.module('app.core').component('quotaTagVariableDialog', {
    controller: Controller,
    templateUrl: 'quota-tag-variable-dialog.html',
    bindings: {
      tags: '<',
      usedTagOwners: '<',
      onAdd: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(glUtils, QuotaVariable) {
    var ctrl = this

    var MAX_NAME_LENGTH = 25
    var SEARCH_THRESHOLD = 10

    ctrl.maxLength = MAX_NAME_LENGTH

    ctrl.$onInit = onInit

    ctrl.matchesQuery = matchesQuery
    ctrl.isSelected = isSelected
    ctrl.isDisabled = isDisabled
    ctrl.getReason = getReason
    ctrl.toggle = toggle
    ctrl.getError = getError
    ctrl.canAdd = canAdd
    ctrl.add = add

    function onInit() {
      ctrl.name = ''
      ctrl.query = null
      ctrl.selected = []
      ctrl.allTags = _.isArray(ctrl.tags) ? ctrl.tags : []
      ctrl.showSearch = ctrl.allTags.length > SEARCH_THRESHOLD
    }

    function matchesQuery(tag) {
      if (!ctrl.query) return true
      return tag.toLowerCase().indexOf(ctrl.query.toLowerCase()) !== -1
    }

    function isSelected(tag) {
      return _.includes(ctrl.selected, tag)
    }

    function isDisabled(tag) {
      return !!getReason(tag)
    }

    function getReason(tag) {
      var owner = (ctrl.usedTagOwners || {})[tag]
      return owner ? 'in ' + owner : null
    }

    function toggle(tag) {
      if (isDisabled(tag)) return

      if (isSelected(tag)) {
        _.remove(ctrl.selected, function(selected) {
          return selected === tag
        })
        return
      }

      ctrl.selected.push(tag)
    }

    function getError() {
      if (getName().length > MAX_NAME_LENGTH) {
        return 'Keep the name to ' + MAX_NAME_LENGTH + ' characters or fewer.'
      }
      return null
    }

    function canAdd() {
      return !!getName().length && !!ctrl.selected.length && !getError()
    }

    function add() {
      if (!canAdd()) return

      var variable = new QuotaVariable()
      variable.type = QuotaVariable.Types.TAG
      variable.displayName = getName()
      variable.options = ctrl.selected.map(function(tag) {
        return { id: glUtils.uuid(), tag: tag }
      })

      ctrl.onAdd({ $variable: variable })
    }

    function getName() {
      return (ctrl.name || '').trim()
    }
  }
})()
